
import React, { useState,useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './carddaydisplay.css'


import {editActivityData} from '../../actions/index'
import {convertMetrics,metricSpeed,metricDistance,metric} from '../../helperFunctions/measurementSystem'



import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
    Input,
  } from "reactstrap";

import 'rc-slider/assets/index.css';


import Aer1 from '../../assets/img/aer1.png'
import Tempo from '../../assets/img/tempo.png'
import Aer2 from '../../assets/img/aer2.png'

import Swim from '../../assets/img/swim.png'
import Base from '../../assets/img/base.png'
import Interval from '../../assets/img/intervalcon.png'
import Ride from '../../assets/img/ride.png'

import Yoga from '../../assets/img/yoga.png'
import Race from '../../assets/img/race.png'
import Workout from '../../assets/img/workout.png'
import Walk from '../../assets/img/walk.png'
import None from '../../assets/img/none.png'

const ActivityDisplayModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  const dispatch = useDispatch()


  const [modal, setModal] = useState(false);

  const [edit,setEdit] = useState(false);
  const [distance,setDistance] = useState((props.activity[2]/1000).toFixed(2))
  const [duration,setDuration] = useState(props.activity[1].toFixed(2))
  const [heartRate,setHeartRate] = useState(props.activity[4])
  const [elevation,setElevation] = useState(props.activity[7])
  const [name,setName] = useState(props.name)
  
  const [subType,setSubType] = useState(props.subType)
  
  
  useEffect(() => {
    setDistance((props.activity[2]/1000).toFixed(2))
    setDuration(props.activity[1].toFixed(2));
    setHeartRate(props.activity[4])
    setElevation(props.activity[7])
    setSubType(props.subType)
    setName(props.name)
  }, [props.activity[0]])

 
  
  const toggle = () => setModal(!modal);
  
  var user = useSelector(state => state.auth)
  

  

  
  
  const reserve = (heartRate) =>{
    var res = (heartRate - user.rest_hr)/(user.max_hr-user.rest_hr)
    res = parseInt(res*100)
    return res
  }

  const setEditState = () =>{
      if (edit){
          setEdit(false)
      }
      else{
          setEdit(true)
      }
  }
  
var rest_hr = user.rest_hr
var max_hr = user.max_hr
var lactate_th = user.lactate_th
if (props.type === "Swim"){
    lactate_th = user.lactate_swim
}
if (props.type === "Ride"){
    lactate_th = user.lactate_cycle
}
//calculate trimp and tss
var hrr = (heartRate-rest_hr)/(max_hr-rest_hr)
var trimp=0
Math.round(duration)
for (var i=0;i<duration;i++){
    trimp = trimp + 1 * hrr * 0.64 * Math.exp(1.92 * hrr)
}
    
var hr_lthr = (lactate_th - rest_hr)/(max_hr - rest_hr)
var hour_lthr = 60 * hr_lthr * 0.64 * Math.exp(1.92 * hr_lthr)
var tss =  (trimp/hour_lthr)*100
if(tss<0){
  tss = 0
}

var runningIndex = 0
if (props.type==="Run"){
  var x = heartRate/max_hr*1.45-0.30
  var up = Number(0)
  var d = distance*1000 + 3*up //d = distance + 6*up //- 4*down changed due to strava not provide down
  var RIO = (213.9/duration) * Math.pow(d/1000,1.06) +3.5
  runningIndex = RIO/x
}

    
  const subTypeImage = () =>{
    if (props.subType === "Aerobic I"){
      return Aer1
    }
    if (props.subType === "Aerobic II"){
      return Aer2
    }
    if (props.subType === "Base"){
      return Base
    }
    if (props.subType === "Interval"){
      return Interval
    }
    if (props.subType === "Threshold"){
      return Tempo
    }
    if (props.subType === "Ride"){
      return Ride
    }
    if (props.subType === "Swim"){
      return Swim
    }
    if (props.subType === "Run"){
      return Tempo
    }
    if (props.subType === "Race"){
      return Race
    }
    if (props.subType === "Yoga"){
      return Yoga
    }
    if (props.subType === "Workout"){
      return Workout
    }
    if (props.subType === "WeightTraining"){
      return Workout
    }
    if (props.subType === "Walk"){
      return Walk
    }
    else{
      return None
    }
    
  }    

  const colorText = () => {
    
    /*if (Number(reserve(heartRate(props.data.hrPerc))) > 90){
      return 'text-danger'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 80){
      return 'text-warning'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 70){
      return 'text-success'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 60){
      return 'text-info'
    }*/
    
    return 'text-white'
    
  }

  const saveChanges = () => {
    const data = {id:props.id,type:props.type,subType:subType,duration:duration,distance:distance*1000,heartRate:heartRate,tss:tss.toFixed(2),trimp:trimp,name:name}  
    dispatch(editActivityData(data))
  }
   
  ///console.log(props.activity)
  //console.log(user)
  
  //var estSpeed = GeneralSpeedCalculate(props.data.dur,props.data.hrPerc,user)
  

  return (
    <div>
      <img onClick={toggle} style={{cursor:'pointer',height:'45px',width:'45px'}} src={subTypeImage()} alt="click" ></img>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>{props.day}</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

                <div className="cardDisplay">
              
                <h2 className="name text-white"><img style={{cursor:'pointer',height:'60px',width:'60px'}} alt="" src={subTypeImage()}></img></h2>
              <h2 className="name text-white">{props.type}</h2>
              {edit ? 
              <>
                <Input type='text' value={name} onChange={(e) => setName(e.target.value)} style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}} ></Input>
                <Input type="select" value={subType} onChange={(e)=>setSubType(e.target.value)}style={{backgroundColor:'rgb(40,40,40)',color:'#F0A936'}}>
                  <option disabled style={{fontStyle:'italic'}}>Basic Tags</option> 
                  <option value ="Interval">Interval</option>
                  <option value ="Race">Race</option>
                  <option value ="None">None</option>
                  <option disabled style={{fontStyle:'italic'}}>Heart Rate tags</option> 
                  <option value ="Aerobic I">Aerobic I</option>
                  <option value ="Aerobic II">Aerobic II</option>
                  <option value ="Threshold">Threshold</option>
                  <option value ="Base">Base</option>
                  <option disabled style={{fontStyle:'italic'}}>Other Sports</option> 
                  <option value ="Ride">Ride</option>
                  <option value ="Swim">Swim</option>
                  
                                    
                </Input>
              </>
              :
              <>
                <div className="title">{name}</div>
                <div className="title">{props.subType}</div>
              </>
              }
              
              <div className="title">{props.activity[0]}</div>
              
              <div className="actions">
              <div className="follow-info">
                <h2><a href="#">
                    {edit ? <Input type='number' style={{color:'rgb(100,150,255)'}} value={duration} onChange={e => setDuration(e.target.value)}/>
                    :
                    <span className="text-success" style={{fontSize:'20px'}}>{duration}</span>}
                    <small>Duration</small>
                    </a>
                </h2>
                    
                
                <>
                  
                  <>
                  
                  <h2><a href="#">
                    {edit ? <Input type='number' style={{color:'rgb(100,150,255)'}} value={distance} onChange={e => setDistance(e.target.value)} />
                    :
                    <span className="text-white" style={{fontSize:'20px'}}>{metricDistance(distance,user.measurementSystem)}</span>}
                    {edit ?  
                    <small>Distance (km)</small>
                    :
                    <small>Distance ({metric(user.measurementSystem)})</small>
                    }
                    
                    
                    </a>
                  </h2>
                  
                  <h2><a href="#"><span className='text-info' style={{fontSize:'20px'}}>{convertMetrics(((distance/duration)*60),user.measurementSystem)} </span><small>Pace ({metricSpeed(user.measurementSystem)})</small></a></h2>
                  
                  </>
                  
                  
                  
                  
                </>
               
                
              </div>
              <div className="follow-info">
                  <h2><a href="#">
                    {edit ? <Input type='number' style={{color:'rgb(100,150,255)'}} value={heartRate} onChange={e => setHeartRate(e.target.value)} />
                    :
                    <span className="text-warning" style={{fontSize:'20px'}}>{heartRate}</span>}
                    <small>Heart rate</small>
                    
                    </a>
                  </h2>
                  <h2><a href="#"><span className="text-danger" style={{fontSize:'20px'}}>{elevation.toFixed(0)}<small className='text-white'>({distance > 0 ? ((elevation*100)/(distance*1000)).toFixed(0) : 0}%)</small></span><small>Total elev gain(m)</small></a></h2>
                  <h2><a href="#"><span className="text-danger" style={{fontSize:'20px'}}>{tss.toFixed(2)}</span><small>Stress score</small></a></h2>
               
              </div>
              <div className="follow-info" style={{alignItems:'center',justifyContent:'center'}}>
              <h2><a href="#"><span className="text-success" style={{fontSize:'20px'}}>{runningIndex.toFixed(2)}</span><small>Performance index</small></a></h2>
              </div>
                <div className="follow-btn">
                {edit ? 
                <>
                <button className="text-white" onClick={setEditState}>Cancel</button>
                </> :
                <button className="text-white" onClick={setEditState}>Edit</button>
                }
                  
                </div>
              </div>
              
              
              <div className="desc"></div>
            </div>
            

  
        
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
        <Button color="info" onClick={saveChanges}>Save changes</Button>
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ActivityDisplayModal;